module.exports = __webpack_public_path__ + "img/edit.7da5d9ea.svg";